/* Adventure cart drawer — opens on add to cart (forms that go straight to
   checkout are left alone), renders the cart from /cart.js, upgrade offer
   to the complete collection, discount codes, totals and checkout. */
(function () {
  if (window.__advCart) return;
  window.__advCart = true;

  var root = null, cfg = null, state = null, lastKey = null, toastTimer = null, lastFocus = null;
  /* Frostwick (Christmas adventure, not part of the Collection): the upgrade offer shows for it too.
     On the Italian site, until Christmas, Frostwick costs 35.29% of its price with the Collection
     (automatic discount "Natale: Frostwick a 6 € con The Complete Collection"). */
  var XM_PID = 12410452017416, XM_PCT = 35.29, XM_END = Date.parse('2026-12-25T23:59:00+01:00');
  var IT = /^it/i.test(document.documentElement.lang || '');

  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function enabled() { return root && root.getAttribute('data-enabled') === 'true'; }
  function url(path) { return (cfg && cfg.root ? cfg.root.replace(/\/?$/, '/') : '/') + path; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = (cfg && cfg.moneyFormat ? cfg.moneyFormat : '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
    cents = Math.round(Number(cents) || 0);
    function num(n, dec, th, dp) {
      var neg = n < 0; n = Math.abs(n);
      var fixed = (n / 100).toFixed(dec).split('.');
      var ints = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return (neg ? '-' : '') + ints + (dec ? dp + fixed[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- requests ---------- */
  function json(path, body) {
    var opts = { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body instanceof FormData) opts.body = body;
    else if (body) { opts.body = JSON.stringify(body); opts.headers['Content-Type'] = 'application/json'; }
    return fetch(url(path), opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function refresh() { return json('cart.js').then(render); }

  /* ---------- open / close ---------- */
  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('advc-lock');
    setTimeout(function () { var p = q('.advc__panel'); p && p.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('advc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function toast(msg, bad) {
    var t = q('[data-advc-toast]'); if (!t) return;
    t.textContent = msg; t.classList.toggle('is-bad', !!bad); t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  /* ---------- render ---------- */
  function splitTitle(it) {
    var t = it.product_title || it.title || '', i = t.indexOf(':');
    return i > -1 ? [t.slice(0, i).trim(), t.slice(i + 1).trim()] : [t, ''];
  }
  function img(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function fill(tpl, map) { return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map.hasOwnProperty(k) ? map[k] : m; }); }

  function render(cart) {
    state = cart;
    var t = cfg.t, items = cart.items || [];
    // counters
    qa('[data-advc-count]').forEach(function (el) { el.textContent = cart.item_count; });
    document.querySelectorAll('.advh-cart').forEach(function (a) {
      var c = a.querySelector('.advh-count');
      if (cart.item_count > 0) { if (!c) { c = document.createElement('span'); c.className = 'advh-count'; a.appendChild(c); } c.textContent = cart.item_count; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
      else if (c) c.remove();
    });
    // items
    var list = q('[data-advc-items]');
    list.innerHTML = items.map(function (it, i) {
      var nm = splitTitle(it), variant = (it.variant_title && !it.product_has_only_default_variant) ? it.variant_title : '';
      /* the Language option (English / Italian) is picked automatically from the storefront language: never show it */
      if (variant && it.options_with_values) variant = it.options_with_values.filter(function (o) { return !/^(language|lingua)$/i.test(String(o.name || '').trim()); }).map(function (o) { return o.value; }).join(' / ');
      var struck = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      var qty = cfg.showQty ?
        '<div class="advc__qty" role="group" aria-label="' + esc(t.qty) + '"><button type="button" data-advc-qty="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="-">−</button><span>' + it.quantity + '</span><button type="button" data-advc-qty="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="+">+</button></div>' :
        (it.quantity > 1 ? '<span class="advc__qx">× ' + it.quantity + '</span>' : '');
      return '<li class="advc__item' + (it.key === lastKey ? ' is-new' : '') + '" style="--i:' + i + '">' +
        '<a class="advc__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(img(it.image, 180)) + '" alt="" loading="lazy" width="90" height="90">' : '') + '</a>' +
        '<div class="advc__info"><a class="advc__name" href="' + esc(it.url) + '">' + esc(nm[0]) + '</a>' +
        (cfg.showSubtitle && nm[1] ? '<span class="advc__sub">' + esc(nm[1]) + '</span>' : '') +
        (variant ? '<span class="advc__sub">' + esc(variant) + '</span>' : '') +
        '<div class="advc__row">' + qty + '<button type="button" class="advc__rm" data-advc-rm="' + esc(it.key) + '">' + esc(t.remove) + '</button></div></div>' +
        '<div class="advc__price">' + struck + '<b>' + money(it.final_line_price) + '</b></div></li>';
    }).join('');
    var empty = items.length === 0;
    q('[data-advc-empty]').hidden = !empty;
    q('[data-advc-foot]').hidden = empty;
    list.hidden = empty;
    // upgrade offer
    var up = q('[data-advc-upsell]');
    if (up && cfg.bundle) {
      var b = cfg.bundle, hasBundle = items.some(function (it) { return it.product_id === b.productId; });
      var singles = items.filter(function (it) { return cfg.singles.indexOf(it.product_id) > -1; });
      var distinct = {}, singlesTotal = 0;
      singles.forEach(function (it) { distinct[it.product_id] = 1; singlesTotal += it.final_line_price; });
      var count = Object.keys(distinct).length, missing = Math.max(0, (b.total || 6) - count);
      var xmLine = items.filter(function (it) { return it.product_id === XM_PID; })[0];
      var xmDeal = !!xmLine && IT && Date.now() < XM_END;
      var show = !hasBundle && (count > 0 || !!xmLine) && b.available;
      up.hidden = !show;
      if (show) {
        var diff = b.price - singlesTotal;
        var word = IT ? (count === 1 ? ' avventura' : ' avventure') : (count === 1 ? ' adventure' : ' adventures');
        var xmFull = xmLine ? xmLine.price : 0;
        var map = { count: count + word, missing: String(missing), diff: money(Math.max(diff, 0)), price: money(b.price),
                    save: money(Math.max((b.compare || 0) - b.price, 0)), saving: money(Math.max(-diff, 0)),
                    compare: money(b.compare || b.price), xm: money(Math.round(xmFull * XM_PCT / 100)), xmfull: money(xmFull) };
        var txt, btnTxt = t.upBtn;
        if (count === 0) {
          /* only Frostwick in the cart: the Collection is added next to it (nothing is replaced) */
          txt = IT ? (xmDeal ? 'Hai Frostwick nel carrello. Aggiungi tutte e 7 le avventure a [price] invece di [compare]: con la Collezione, Frostwick scende a [xm] invece di [xmfull].'
                             : 'Hai Frostwick nel carrello. Aggiungi tutte e 7 le avventure a [price] invece di [compare] e risparmi [save].')
                   : 'You have Frostwick in your cart. Add all 7 adventures for [price] instead of [compare] and save [save].';
          btnTxt = IT ? 'Aggiungi tutte e 7 · [price]' : 'Add all 7 · [price]';
        } else {
          txt = diff > 0 ? t.upText : t.upTextFree;
          if (xmDeal) txt += ' Con la Collezione, Frostwick scende a [xm].';
        }
        q('[data-advc-up-text]').textContent = fill(txt, map);
        q('[data-advc-up-btn]').textContent = fill(btnTxt, map);
        var note = q('.advc__up-note', up); if (note) note.style.display = count === 0 ? 'none' : '';
      }
    }
    // trio offer
    var tb = q('[data-advc-trio]');
    if (tb && cfg.trio) {
      var tr = cfg.trio, tids = tr.items.map(function (x) { return x.pid; });
      var inCart = {}, tcount = 0, tsave = 0, tmin = Infinity;
      items.forEach(function (it) {
        if (tids.indexOf(it.product_id) < 0) return;
        inCart[it.product_id] = 1; tcount += it.quantity;
        if (it.price < tmin) tmin = it.price;
        (it.line_level_discount_allocations || []).forEach(function (a) {
          var ttl = (a.discount_application && a.discount_application.title) || '';
          if (!tr.match || ttl.toLowerCase().indexOf(String(tr.match).toLowerCase()) > -1) tsave += a.amount;
        });
      });
      var hasB = cfg.bundle && items.some(function (it) { return it.product_id === cfg.bundle.productId; });
      var picks = tr.items.filter(function (x) { return x.ok && !inCart[x.pid]; });
      picks.forEach(function (x) { if (x.price < tmin) tmin = x.price; });
      var showT = !hasB && tcount > 0 && (tcount % 3 !== 0 || tsave > 0);
      tb.hidden = !showT;
      if (showT) {
        var pct = parseFloat(String(tr.pct).replace(',', '.')) || 0;
        var third = tmin - Math.floor(tmin * pct / 100), rest = tcount % 3; // same rounding as Shopify's checkout
        var tmap = { third: money(third), trio: money(tmin * 2 + third), saving: money(tsave) };
        var msg = tcount === 1 ? t.trio1 : tcount === 2 ? t.trio2 : rest === 2 ? t.trioDone + ' ' + t.trioMore : t.trioDone;
        q('[data-advc-trio-text]').textContent = fill(msg, tmap);
        tb.classList.toggle('is-done', tcount >= 3);
        qa('[data-advc-trio-slots] i').forEach(function (el, i) { el.classList.toggle('on', i < (tcount >= 3 && rest !== 2 ? 3 : rest)); });
        var pl = q('[data-advc-trio-picks]');
        var showPicks = (tcount < 3 || rest === 2) ? picks.slice(0, tr.max || 3) : [];
        pl.hidden = !showPicks.length;
        pl.innerHTML = showPicks.map(function (x) {
          var p = rest === 2 ? third : x.price;
          return '<li><button type="button" class="advc__trio-pick" data-advc-trio-add="' + x.vid + '" aria-label="' + esc(t.trioAdd + ': ' + x.name) + '">' +
            (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="44" height="44">' : '') +
            '<span class="advc__trio-name">' + esc(x.name) + '</span>' +
            '<span class="advc__trio-add">+ ' + (rest === 2 && p < x.price ? '<s>' + money(x.price) + '</s> ' : '') + money(p) + '</span></button></li>';
        }).join('');
      }
    }
    // totals
    var disc = cart.total_discount || 0;
    q('[data-advc-sub]').textContent = money(cart.original_total_price != null ? cart.original_total_price : cart.total_price + disc);
    q('[data-advc-row-disc]').hidden = disc <= 0;
    q('[data-advc-disc-amt]').textContent = '−' + money(disc);
    q('[data-advc-total]').textContent = money(cart.total_price);
    var ck = q('[data-advc-ck-total]'); if (ck) ck.textContent = money(cart.total_price);
    // discount codes
    var codes = q('[data-advc-codes]');
    if (codes) {
      var list2 = (cart.discount_codes || []).filter(function (c) { return c.applicable; });
      codes.innerHTML = list2.map(function (c) { return '<li><span>' + esc(c.code) + '</span><button type="button" data-advc-code-rm="' + esc(c.code) + '" aria-label="' + esc(t.discRemove) + ' ' + esc(c.code) + '">×</button></li>'; }).join('');
    }
  }

  /* ---------- actions ---------- */
  function change(key, qty) {
    root.classList.add('is-busy');
    return json('cart/change.js', { id: key, quantity: qty }).then(render)
      .catch(function (e) { toast((e && e.description) || cfg.t.error, true); })
      .then(function () { root.classList.remove('is-busy'); });
  }
  function upgrade() {
    var b = cfg.bundle, updates = {};
    if (cfg.replace) (state.items || []).forEach(function (it) { if (cfg.singles.indexOf(it.product_id) > -1) updates[it.variant_id] = 0; });
    updates[b.variantId] = 1;
    root.classList.add('is-busy');
    return json('cart/update.js', { updates: updates }).then(function (cart) {
      var bi = (cart.items || []).filter(function (it) { return it.variant_id === b.variantId || it.product_id === b.productId; })[0];
      lastKey = bi ? bi.key : null; render(cart); toast(cfg.t.upDone);
      var body = q('[data-advc-body]'); if (body) body.scrollTop = 0;
    }).catch(function (e) { toast((e && e.description) || cfg.t.error, true); })
      .then(function () { root.classList.remove('is-busy'); });
  }
  function trioAdd(btn) {
    var vid = parseInt(btn.getAttribute('data-advc-trio-add'), 10);
    root.classList.add('is-busy'); btn.disabled = true;
    return json('cart/add.js', { items: [{ id: vid, quantity: 1 }] }).then(function (res) {
      var added = res.items ? res.items[0] : res; lastKey = added && added.key;
      return refresh().then(function () { if (added) toast(fill(cfg.t.added, { name: splitTitle(added)[0] })); });
    }).catch(function (e) { toast((e && e.description) || cfg.t.error, true); })
      .then(function () { root.classList.remove('is-busy'); btn.disabled = false; });
  }
  function discMsg(msg, kind) {
    var m = q('[data-advc-disc-msg]'); if (!m) return;
    m.textContent = msg || ''; m.className = 'advc__disc-msg' + (kind ? ' is-' + kind : '');
  }
  function codesNow() { return ((state && state.discount_codes) || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; }); }
  function laterFallback(code) {
    return fetch(url('discount/' + encodeURIComponent(code)), { credentials: 'same-origin' })
      .then(function () { discMsg(cfg.t.discLater, 'ok'); })
      .catch(function () { discMsg(cfg.t.error, 'bad'); });
  }
  function applyCode(code) {
    code = (code || '').trim(); if (!code) return;
    var before = codesNow();
    root.classList.add('is-busy');
    return json('cart/update.js', { discount: before.concat([code]).join(',') }).then(function (cart) {
      if (!Array.isArray(cart.discount_codes)) { render(cart); return laterFallback(code); }
      var hit = cart.discount_codes.filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) { render(cart); discMsg(cfg.t.discOk, 'ok'); var inp = q('[data-advc-disc-form] input'); if (inp) inp.value = ''; return; }
      discMsg(cfg.t.discBad, 'bad');
      return json('cart/update.js', { discount: before.join(',') }).then(render);
    }).catch(function () { return laterFallback(code); })
      .then(function () { root.classList.remove('is-busy'); });
  }
  function removeCode(code) {
    var rest = codesNow().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    return json('cart/update.js', { discount: rest.join(',') }).then(function (cart) { render(cart); discMsg(''); });
  }

  /* ---------- add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!enabled() || !f || f.tagName !== 'FORM') return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') < 0) return;
    var rt = f.querySelector('input[name="return_to"]');
    if (rt && /checkout/.test(rt.value)) return; // direct checkout buttons keep their behaviour
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = e.submitter || f.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    json('cart/add.js', new FormData(f)).then(function (res) {
      var added = res.items ? res.items[0] : res;
      lastKey = added && added.key;
      return refresh().then(function () {
        open();
        if (added) toast(fill(cfg.t.added, { name: splitTitle(added)[0] }));
      });
    }).catch(function (err) {
      return refresh().then(function () { open(); toast((err && (err.description || err.message)) || cfg.t.error, true); });
    }).then(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.disabled = false; }
    });
  }, true);

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    if (!root) return;
    var t = e.target;
    var icon = t.closest && t.closest('.advh-cart');
    if (icon && enabled() && root.getAttribute('data-icon-opens') === 'true') { e.preventDefault(); refresh().then(open); return; }
    if (!root.contains(t)) {
      // click anywhere on the page outside the drawer closes it
      if (root.classList.contains('is-open') && !t.closest('.advc__panel')) close();
      return;
    }
    if (t.closest('[data-advc-close]') || !t.closest('.advc__panel')) { e.preventDefault(); close(); return; }
    var rm = t.closest('[data-advc-rm]'); if (rm) { change(rm.getAttribute('data-advc-rm'), 0); return; }
    var qb = t.closest('[data-advc-qty]'); if (qb) { change(qb.getAttribute('data-advc-qty'), Math.max(0, parseInt(qb.getAttribute('data-q'), 10))); return; }
    if (t.closest('[data-advc-upgrade]')) { upgrade(); return; }
    var ta = t.closest('[data-advc-trio-add]'); if (ta) { trioAdd(ta); return; }
    var cr = t.closest('[data-advc-code-rm]'); if (cr) { removeCode(cr.getAttribute('data-advc-code-rm')); return; }
  });
  document.addEventListener('submit', function (e) {
    if (!root || !e.target.matches || !e.target.matches('[data-advc-disc-form]')) return;
    e.preventDefault();
    applyCode(e.target.querySelector('input').value);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && root.classList.contains('is-open')) close(); });

  /* ---------- init + theme editor ---------- */
  function init() {
    // The drawer is moved straight under <body> so no header / sticky section
    // (with its own stacking order) can ever sit on top of it.
    var all = Array.prototype.slice.call(document.querySelectorAll('[data-adv-cart]'));
    if (!all.length) { root = null; return; }
    var fresh = all.filter(function (el) { return el.parentNode !== document.body; })[0] || all[0];
    all.forEach(function (el) { if (el !== fresh) el.parentNode.removeChild(el); });
    if (fresh.parentNode !== document.body) document.body.appendChild(fresh);
    root = fresh;
    try { cfg = JSON.parse(root.querySelector('[data-advc-config]').textContent); } catch (err) { root = null; return; }
    refresh().catch(function () {});
  }
  function isCart(e) { return e.detail && document.getElementById('advc-' + e.detail.sectionId); }
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('[data-adv-cart]')) init(); });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = isCart(e); if (el) { close(); el.parentNode.removeChild(el); root = null; }
  });
  document.addEventListener('shopify:section:select', function (e) { if (isCart(e)) { init(); refresh().then(open); } });
  document.addEventListener('shopify:section:deselect', function (e) { if (isCart(e)) close(); });
  window.advCart = { open: function () { return refresh().then(open); }, close: close, refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
